(function () {
  var STYLE_ID = 'hp-max-upsell-polish-v40-style';

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[־–—]/g, '-')
      .trim();
  }

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
/* =========================================================
   HeroPack MAX upsell polish v40
   Desktop + safe mobile styling
   ========================================================= */

#MainContent .hp-max-v40-section,
#MainContent .hp-max-v40-section *{
  box-sizing:border-box!important;
}

/* ---------- Desktop ---------- */
@media screen and (min-width:990px){

  #MainContent .hp-max-v40-section{
    overflow:visible!important;
  }

  #MainContent .hp-max-v40-section .hp-max-upgrade{
    grid-template-columns:44% 56%!important;
    gap:24px!important;
    align-items:center!important;
  }

  #MainContent .hp-max-v40-section .hp-max-media{
    transform:none!important;
    padding-top:0!important;
  }

  #MainContent .hp-max-v40-section .hp-max-content,
  #MainContent .hp-max-v40-content{
    text-align:center!important;
    direction:rtl!important;
    padding-left:18px!important;
    padding-right:18px!important;
  }

  /* Badge: רגע לפני התשלום */
  #MainContent .hp-max-v40-badge{
    display:inline-flex!important;
    align-items:center!important;
    justify-content:center!important;

    margin:0 auto 14px!important;
    padding:8px 18px!important;

    border-radius:999px!important;
    border:1px solid rgba(255,224,130,.62)!important;
    background:rgba(255,224,130,.13)!important;

    color:#FFE082!important;
    font-size:16px!important;
    line-height:1.15!important;
    font-weight:950!important;

    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.18),
      0 8px 18px rgba(0,0,0,.15)!important;

    white-space:nowrap!important;
  }

  /* Title: שדרגו ל־HeroPack MAX */
  #MainContent .hp-max-v40-title{
    display:flex!important;
    flex-direction:row!important;
    align-items:baseline!important;
    justify-content:center!important;
    gap:10px!important;

    width:100%!important;
    max-width:100%!important;
    margin:0 auto 14px!important;
    padding:0 6px!important;

    direction:rtl!important;
    text-align:center!important;
    white-space:nowrap!important;
    overflow:visible!important;

    font-family:Assistant, Arial, sans-serif!important;
    line-height:1!important;
    transform:none!important;
  }

  #MainContent .hp-max-v40-title .hp-max-v40-title-prefix{
    display:inline-block!important;
    color:#ffffff!important;
    font-size:34px!important;
    line-height:1!important;
    font-weight:900!important;
    letter-spacing:-0.02em!important;
  }

  #MainContent .hp-max-v40-title .hp-max-v40-title-main{
    display:inline-block!important;
    color:#FFE082!important;
    font-size:clamp(44px,4.1vw,58px)!important;
    line-height:1!important;
    font-weight:950!important;
    letter-spacing:-0.035em!important;
    text-shadow:0 3px 14px rgba(0,0,0,.28)!important;
  }

  /* Button: premium gold */
  #MainContent .hp-max-v40-button{
    position:relative!important;
    isolation:isolate!important;
    overflow:hidden!important;

    width:100%!important;
    max-width:330px!important;
    min-height:58px!important;

    margin:18px auto 12px!important;
    padding:0 34px!important;

    display:inline-flex!important;
    align-items:center!important;
    justify-content:center!important;

    border-radius:999px!important;
    border:2px solid rgba(255,238,170,.78)!important;

    background:
      linear-gradient(180deg,#FFE891 0%,#F6D35E 45%,#DFAE27 100%)!important;

    color:#0E1B4D!important;
    font-size:18px!important;
    line-height:1.15!important;
    font-weight:950!important;
    text-align:center!important;
    text-decoration:none!important;

    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.7),
      inset 0 -2px 0 rgba(128,88,0,.20),
      0 12px 24px rgba(0,0,0,.22),
      0 0 0 4px rgba(255,224,130,.08)!important;

    cursor:pointer!important;
    transform:none!important;
  }

  #MainContent .hp-max-v40-button::before{
    content:""!important;
    position:absolute!important;
    top:-80%!important;
    left:-40%!important;
    width:40%!important;
    height:240%!important;
    background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent)!important;
    transform:rotate(24deg)!important;
    opacity:.55!important;
    z-index:-1!important;
  }

  #MainContent .hp-max-v40-button:hover{
    transform:translateY(-1px)!important;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.75),
      inset 0 -2px 0 rgba(128,88,0,.22),
      0 16px 28px rgba(0,0,0,.26),
      0 0 0 5px rgba(255,224,130,.12)!important;
  }

  #MainContent .hp-max-v40-button:active{
    transform:translateY(1px)!important;
  }
}

/* ---------- Mobile safe styling ---------- */
@media screen and (max-width:989px){

  #MainContent .hp-max-v40-badge{
    display:inline-flex!important;
    align-items:center!important;
    justify-content:center!important;
    margin:0 auto 10px!important;
    padding:6px 14px!important;
    border-radius:999px!important;
    border:1px solid rgba(255,224,130,.55)!important;
    background:rgba(255,224,130,.14)!important;
    color:#FFE082!important;
    font-size:13px!important;
    line-height:1.15!important;
    font-weight:900!important;
    white-space:nowrap!important;
  }

  #MainContent .hp-max-v40-title{
    display:flex!important;
    flex-direction:column!important;
    align-items:center!important;
    justify-content:center!important;
    gap:3px!important;
    margin:0 auto 12px!important;
    padding:0 8px!important;
    text-align:center!important;
    direction:rtl!important;
    white-space:normal!important;
    overflow:visible!important;
  }

  #MainContent .hp-max-v40-title .hp-max-v40-title-prefix{
    display:block!important;
    color:#ffffff!important;
    font-size:23px!important;
    line-height:1.05!important;
    font-weight:900!important;
  }

  #MainContent .hp-max-v40-title .hp-max-v40-title-main{
    display:block!important;
    color:#FFE082!important;
    font-size:34px!important;
    line-height:1!important;
    font-weight:950!important;
    letter-spacing:-0.025em!important;
    text-shadow:0 3px 12px rgba(0,0,0,.25)!important;
  }

  #MainContent .hp-max-v40-button{
    width:100%!important;
    max-width:330px!important;
    min-height:54px!important;
    margin:16px auto 10px!important;
    padding:0 26px!important;

    display:inline-flex!important;
    align-items:center!important;
    justify-content:center!important;

    border-radius:999px!important;
    border:2px solid rgba(255,238,170,.72)!important;
    background:linear-gradient(180deg,#FFE891 0%,#F6D35E 48%,#DFAE27 100%)!important;
    color:#0E1B4D!important;

    font-size:17px!important;
    line-height:1.15!important;
    font-weight:950!important;
    text-align:center!important;
    text-decoration:none!important;

    box-shadow:
      inset 0 1px 0 rgba(255,255,255,.65),
      0 10px 22px rgba(0,0,0,.22)!important;
  }
}
`;

    document.head.appendChild(style);
  }

  function isInsideBlockedArea(el) {
    return !!el.closest(
      '.product, .product__info-container, .product__media-wrapper, cart-drawer, #CartDrawer, .cart-drawer'
    );
  }

  function findMaxTitle() {
    var nodes = document.querySelectorAll(
      '#MainContent h1, #MainContent h2, #MainContent h3, #MainContent .title, #MainContent [class*="heading"], #MainContent [class*="title"]'
    );

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isInsideBlockedArea(el)) continue;

      var text = cleanText(el.textContent);

      if (
        text.indexOf('שדרגו') !== -1 &&
        text.indexOf('HeroPack') !== -1 &&
        text.indexOf('MAX') !== -1
      ) {
        return el;
      }
    }

    return null;
  }

  function markBadge(section) {
    if (!section) return;

    var nodes = section.querySelectorAll('span, div, p, strong, em');

    nodes.forEach(function (el) {
      var text = cleanText(el.textContent);

      if (
        text.indexOf('רגע לפני') !== -1 &&
        text.length <= 45 &&
        !el.closest('button, a')
      ) {
        el.classList.add('hp-max-v40-badge');
        el.textContent = 'רגע לפני התשלום';
      }
    });
  }

  function markButton(section) {
    if (!section) return;

    var buttons = section.querySelectorAll('a, button');

    buttons.forEach(function (btn) {
      var text = cleanText(btn.textContent);

      if (
        text.indexOf('שדרגו') !== -1 &&
        text.indexOf('HeroPack') !== -1 &&
        text.indexOf('MAX') !== -1
      ) {
        btn.classList.add('hp-max-v40-button');
        btn.textContent = 'שדרגו ל־HeroPack MAX';
      }
    });
  }

  function polishTitle(title) {
    if (!title) return;

    title.classList.add('hp-max-v40-title');
    title.innerHTML =
      '<span class="hp-max-v40-title-prefix">שדרגו ל־</span>' +
      '<span class="hp-max-v40-title-main">HeroPack MAX</span>';
  }

  function markSection(title) {
    if (!title) return null;

    var section =
      title.closest('.shopify-section') ||
      title.closest('section') ||
      title.closest('[id^="shopify-section"]') ||
      title.parentElement;

    if (!section) return null;

    section.classList.add('hp-max-v40-section');

    var content =
      title.closest('.hp-max-content') ||
      title.closest('[class*="content"]') ||
      title.parentElement;

    if (content) {
      content.classList.add('hp-max-v40-content');
    }

    return section;
  }

  function run() {
    injectStyle();

    var title = findMaxTitle();
    if (!title) return;

    var section = markSection(title);

    polishTitle(title);
    markBadge(section);
    markButton(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 150);
    setTimeout(run, 700);
  });

  window.addEventListener('resize', function () {
    setTimeout(run, 150);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });
})();

(function () {
  var STYLE_ID = 'hp-mobile-cart-scroll-unlock-final';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = `
/* =========================================================
   HeroPack mobile cart drawer scroll unlock final
   Fix: cart drawer must show regular item + MAX upsell + total + checkout.
   ========================================================= */

@media screen and (max-width:749px){

  html body cart-drawer.drawer,
  html body cart-drawer,
  html body #CartDrawer,
  html body .cart-drawer{
    position:fixed!important;
    inset:0!important;
    width:100vw!important;
    max-width:100vw!important;
    height:100dvh!important;
    max-height:100dvh!important;
    overflow:hidden!important;
    z-index:999999!important;
  }

  html body cart-drawer .drawer__inner,
  html body #CartDrawer .drawer__inner,
  html body .cart-drawer .drawer__inner{
    position:fixed!important;
    top:auto!important;
    right:0!important;
    left:0!important;
    bottom:0!important;

    width:100vw!important;
    max-width:100vw!important;
    min-width:0!important;

    height:auto!important;
    min-height:0!important;
    max-height:92dvh!important;

    margin:0!important;
    padding:0!important;

    display:block!important;
    background:#fff!important;
    border-radius:24px 24px 0 0!important;
    box-shadow:0 -18px 45px rgba(0,0,0,.22)!important;

    overflow-y:auto!important;
    overflow-x:hidden!important;
    -webkit-overflow-scrolling:touch!important;

    box-sizing:border-box!important;
  }

  html body cart-drawer .drawer__header,
  html body #CartDrawer .drawer__header,
  html body .cart-drawer .drawer__header{
    position:sticky!important;
    top:0!important;
    z-index:20!important;

    width:100%!important;
    height:56px!important;
    min-height:56px!important;

    background:#fff!important;
    border-bottom:1px solid rgba(14,27,77,.10)!important;
  }

  html body cart-drawer .drawer__contents,
  html body #CartDrawer .drawer__contents,
  html body .cart-drawer .drawer__contents,
  html body cart-drawer form,
  html body #CartDrawer form,
  html body .cart-drawer form{
    display:block!important;

    height:auto!important;
    min-height:0!important;
    max-height:none!important;

    overflow:visible!important;
  }

  html body cart-drawer cart-drawer-items,
  html body #CartDrawer cart-drawer-items,
  html body .cart-drawer cart-drawer-items{
    display:block!important;

    height:auto!important;
    min-height:0!important;
    max-height:none!important;

    padding:14px 16px 12px!important;
    margin:0!important;

    overflow:visible!important;
    box-sizing:border-box!important;
  }

  html body cart-drawer .drawer__footer,
  html body #CartDrawer .drawer__footer,
  html body .cart-drawer .drawer__footer,
  html body cart-drawer .cart-drawer__footer,
  html body #CartDrawer .cart-drawer__footer,
  html body .cart-drawer .cart-drawer__footer{
    position:static!important;

    width:100%!important;
    max-width:100%!important;

    margin:0!important;
    padding:10px 18px calc(18px + env(safe-area-inset-bottom))!important;

    background:#fff!important;
    border-top:1px solid rgba(14,27,77,.10)!important;

    overflow:visible!important;
    box-sizing:border-box!important;
  }

  html body cart-drawer .hp-cart-max-upsell{
    margin:0 0 14px!important;
  }

  html body cart-drawer .cart__checkout-button,
  html body #CartDrawer .cart__checkout-button,
  html body .cart-drawer .cart__checkout-button{
    display:flex!important;
    width:100%!important;
    max-width:100%!important;
    min-height:52px!important;
    height:52px!important;
    border-radius:999px!important;
  }

  html body cart-drawer .totals,
  html body #CartDrawer .totals,
  html body .cart-drawer .totals{
    display:flex!important;
    width:100%!important;
    max-width:100%!important;
    margin:0 0 12px!important;
    padding:0!important;
  }
}
`;

    document.head.appendChild(style);
  }

  function unlockMobileCartScroll() {
    if (!window.matchMedia || !window.matchMedia('(max-width:749px)').matches) return;

    document.querySelectorAll('cart-drawer, #CartDrawer, .cart-drawer').forEach(function (drawer) {
      var inner = drawer.querySelector('.drawer__inner');
      var contents = drawer.querySelector('.drawer__contents');
      var items = drawer.querySelector('cart-drawer-items');
      var footer = drawer.querySelector('.drawer__footer, .cart-drawer__footer');

      if (inner) {
        inner.style.setProperty('overflow-y', 'auto', 'important');
        inner.style.setProperty('overflow-x', 'hidden', 'important');
        inner.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
        inner.style.setProperty('max-height', '92dvh', 'important');
        inner.style.setProperty('display', 'block', 'important');
      }

      if (contents) {
        contents.style.setProperty('overflow', 'visible', 'important');
        contents.style.setProperty('max-height', 'none', 'important');
        contents.style.setProperty('height', 'auto', 'important');
        contents.style.setProperty('display', 'block', 'important');
      }

      if (items) {
        items.style.setProperty('overflow', 'visible', 'important');
        items.style.setProperty('max-height', 'none', 'important');
        items.style.setProperty('height', 'auto', 'important');
      }

      if (footer) {
        footer.style.setProperty('position', 'static', 'important');
        footer.style.setProperty('overflow', 'visible', 'important');
      }
    });
  }

  function run() {
    injectStyle();
    unlockMobileCartScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 100);
    setTimeout(run, 500);
    setTimeout(run, 1200);
  });

  document.addEventListener('click', function () {
    setTimeout(run, 120);
    setTimeout(run, 500);
  }, true);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 150);
  });

  new MutationObserver(function () {
    setTimeout(unlockMobileCartScroll, 80);
  }).observe(document.documentElement, {
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:['class', 'open', 'style']
  });
})();